module.exports = __webpack_public_path__ + "static/media/Dropdown.897764eb.svg";